import React, { useCallback, useMemo } from 'react';

import ModalCDS from '@sharedCR/coreDesignSystem/Modals/ModalCDS';
import { ModalSize } from '@sharedCR/coreDesignSystem/Modals/ModalCDS/ModalCDS.constants';
import PropTypes from 'prop-types';

import { COMPARE_MODAL_ID } from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getVersionOptions } from '../../FormChangeHistory.utils';
import VersionCompareContent from '../VersionCompareContent';
import VersionCompareHeader from '../VersionCompareHeader';

/**
 * "Compare with current", full window: a version picked from the drawer's loaded rows against the
 * form as it is now. `auditId` stays set while the modal closes.
 */
const FormVersionCompareModal = ({
  isOpen,
  auditId = null,
  rows,
  getRowDecoration = null,
  onSelectVersion,
  onBack,
  onClose,
}) => {
  const options = useMemo(
    () => getVersionOptions(rows, getRowDecoration),
    [rows, getRowDecoration],
  );

  const renderBody = useCallback(() => <VersionCompareContent auditId={auditId} />, [auditId]);

  return (
    <ModalCDS
      isRestyled
      afterCloseCallback={onClose}
      body={renderBody}
      customHead={
        <VersionCompareHeader
          auditId={auditId}
          options={options}
          onBack={onBack}
          onSelectVersion={onSelectVersion}
        />
      }
      dataTestId={FormChangeHistoryTestIds.COMPARE_MODAL}
      id={COMPARE_MODAL_ID}
      keepMounted={false}
      open={isOpen && !!auditId}
      size={ModalSize.FULL}
    />
  );
};

FormVersionCompareModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectVersion: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  auditId: PropTypes.string,
  getRowDecoration: PropTypes.func,
};

export default FormVersionCompareModal;
